
















import Vue from "vue";
import Component from "vue-class-component";
import securityService from "@/auth/securityService";

@Component
export default class LoginForm extends Vue {
  password = "";
  err = "";
  pending = false;

  accept() {
    if (this.pending) return;

    this.err = '';
    this.pending = true;
    securityService.login(this.password)
      .catch(err => {
        this.err = err.message || "Błąd logowania";
      })
      .finally(() => this.pending = false);
  }
}
